<template>
  <div class="aj-rating">
    <aj-star
      v-if="compact"
      :active="initialRating > 0"
      v-bind="getStarAttrs(initialRating)"
      class="aj-rating__stars"
    />
    <div
      v-else
      ref="main"
      class="aj-rating__stars"
    >
      <aj-star
        v-for="rate in maxRating"
        :key="rate"
        v-bind="getStarAttrs(rate)"
        @mouseover="mouseOver(rate)"
        @mouseout="mouseOver(0)"
        @click="setRate(rate)"
      />
    </div>

    <div
      v-if="!clickable"
      :style="`width: ${percentRowWidth}`"
      class="aj-rating__percentContainer"
    >
      <aj-star
        v-for="rate in maxRating"
        :key="rate"
        v-bind="getStarAttrs(null)"
        active
      />
    </div>

    <slot name="ratingValue">
      <aj-text
        v-if="showValue && initialRating > 0"
        tag="span"
        class="aj-rating__value"
        v-bind="ratingValueProps"
      >
        {{ rating }}
      </aj-text>
    </slot>
    <slot name="additionalInfo" />
  </div>
</template>

<script>
import AjStar from '../AjStar/AjStar.vue';
import AjText from '../AjText/AjText.vue';

export default {
  name: 'AjRating',

  components: {
    AjStar,
    AjText,
  },

  props: {
    initialRating: {
      type: Number,
      required: true,
    },

    clickable: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },

    big: {
      type: Boolean,
      default: false,
    },

    large: {
      type: Boolean,
      default: false,
    },

    compact: {
      type: Boolean,
      default: false,
    },

    showValue: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      hoverRating: 0,
      maxRating: 5,
      rating: 0,
      percentRowWidth: 0,
    };
  },

  computed: {
    ratingValueProps () {
      return {
        'body-low': this.small,
        'body-medium': this.big,
        'body-large': this.large,
        bold: true,
      };
    },
  },

  watch: {
    initialRating (rating) {
      this.rating = this.roundValue(rating);
      this.calculateSize();
    },
  },

  mounted () {
    this.rating = this.roundValue(this.initialRating);
    setTimeout(this.calculateSize, 50);
  },

  methods: {
    getStarAttrs (rate = null) {
      const attrsObj = {
        small: this.small,
        big: this.big,
        large: this.large,
        clickable: this.clickable,
      };
      if (rate) {
        attrsObj.selected = this.hoverRating > 0 && this.hoverRating >= rate;
        attrsObj.active = rate <= this.rating;
      }
      return attrsObj;
    },

    setRate (rate) {
      if (!this.clickable) {
        return;
      }

      this.rating = rate;
      this.$emit('input', rate);
    },

    mouseOver (rate) {
      if (!this.clickable) {
        return;
      }

      this.hoverRating = rate;
    },

    calculateSize () {
      if (!this.$refs.main) {
        return false;
      }

      const ratio = this.rating / this.maxRating;
      const container = this.$refs.main.offsetWidth;
      const val = ratio * container;
      this.percentRowWidth = `${val}px`;

      return true;
    },

    roundValue (value) {
      return Math.round(value * 10) / 10;
    },
  },
};
</script>

<style lang="scss" scoped src="./AjRating.scss" />
